export default __webpack_public_path__ + "static/media/dlpm.2076a924.png";